!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e(require("react"), require("classnames"));else if ("function" == typeof define && define.amd) define(["react", "classnames"], e);else {
    var n = "object" == typeof exports ? e(require("react"), require("classnames")) : e(t.react, t.classnames);

    for (var r in n) {
      ("object" == typeof exports ? exports : t)[r] = n[r];
    }
  }
}("undefined" != typeof self ? self : this, function (t, e) {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 104);
  }({
    0: function _(e, n) {
      e.exports = t;
    },
    1: function _(t, n) {
      t.exports = e;
    },
    104: function _(t, e, n) {
      "use strict";

      var _r,
          o = this && this.__extends || (_r = function r(t, e) {
        return (_r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(t, e);
      }, function (t, e) {
        function n() {
          this.constructor = t;
        }

        _r(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
      }),
          i = this && this.__assign || function () {
        return (i = Object.assign || function (t) {
          for (var e, n = 1, r = arguments.length; n < r; n++) {
            for (var o in e = arguments[n]) {
              Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            }
          }

          return t;
        }).apply(this, arguments);
      },
          a = this && this.__rest || function (t, e) {
        var n = {};

        for (var r in t) {
          Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
        }

        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;

          for (r = Object.getOwnPropertySymbols(t); o < r.length; o++) {
            e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
          }
        }

        return n;
      },
          s = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var c = s(n(0)),
          u = s(n(1)),
          l = n(168),
          d = n(165),
          f = l.MDCNotchedOutlineFoundation.cssClasses,
          p = function (t) {
        function e() {
          var e = null !== t && t.apply(this, arguments) || this;
          return e.notchedEl = c.default.createRef(), e.state = {
            classList: new Set(),
            foundationNotchWidth: void 0
          }, e.addClass = function (t) {
            e.setState(function (e) {
              var n = new Set(e.classList);
              return n.add(t), {
                classList: n
              };
            });
          }, e.notch = function () {
            var t = e.props,
                n = t.notchWidth,
                r = t.notch;
            e.foundation && (r ? e.foundation.notch(n) : e.foundation.closeNotch());
          }, e;
        }

        return o(e, t), e.prototype.componentDidMount = function () {
          var t = this;
          this.foundation = new l.MDCNotchedOutlineFoundation(this.adapter), this.foundation.init(), this.notch(), this.label && (this.label.style.transitionDuration = "0s", this.addClass(f.OUTLINE_UPGRADED), requestAnimationFrame(function () {
            t.label && (t.label.style.transitionDuration = "");
          }));
        }, e.prototype.componentWillUnmount = function () {
          this.foundation && this.foundation.destroy();
        }, e.prototype.componentDidUpdate = function (t) {
          this.props.notchWidth === t.notchWidth && this.props.notch === t.notch || this.notch();
        }, Object.defineProperty(e.prototype, "classes", {
          get: function get() {
            var t,
                e = this.state.classList,
                n = this.props.className;
            return u.default("mdc-notched-outline", Array.from(e), n, ((t = {})[f.NO_LABEL] = !this.label, t));
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "label", {
          get: function get() {
            return this.notchedEl.current ? this.notchedEl.current.querySelector("." + d.MDCFloatingLabelFoundation.cssClasses.ROOT) : null;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "adapter", {
          get: function get() {
            var t = this;
            return {
              addClass: this.addClass,
              removeClass: function removeClass(e) {
                t.setState(function (t) {
                  var n = new Set(t.classList);
                  return n.delete(e), {
                    classList: n
                  };
                });
              },
              setNotchWidthProperty: function setNotchWidthProperty(e) {
                return t.setState({
                  foundationNotchWidth: e
                });
              },
              removeNotchWidthProperty: function removeNotchWidthProperty() {
                return t.setState({
                  foundationNotchWidth: void 0
                });
              }
            };
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.render = function () {
          var t = this.props,
              e = t.children,
              n = (t.className, t.notchWidth, t.notch, a(t, ["children", "className", "notchWidth", "notch"])),
              r = this.state.foundationNotchWidth,
              o = {
            width: r ? r + "px" : void 0
          };
          return c.default.createElement("div", i({
            className: this.classes,
            ref: this.notchedEl
          }, n), c.default.createElement("div", {
            className: "mdc-notched-outline__leading"
          }), e ? c.default.createElement("div", {
            className: "mdc-notched-outline__notch",
            style: o
          }, c.default.Children.only(e)) : null, c.default.createElement("div", {
            className: "mdc-notched-outline__trailing"
          }));
        }, e.defaultProps = {
          className: "",
          notchWidth: 0,
          notch: !1
        }, e;
      }(c.default.Component);

      e.default = p;
    },
    165: function _(t, e, n) {
      "use strict";

      n.r(e);
      var r = n(22),
          o = n(29),
          i = {
        LABEL_FLOAT_ABOVE: "mdc-floating-label--float-above",
        LABEL_SHAKE: "mdc-floating-label--shake",
        ROOT: "mdc-floating-label"
      };
      n.d(e, "MDCFloatingLabelFoundation", function () {
        return a;
      });
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */

      var a = function (t) {
        function e(n) {
          var o = t.call(this, r.a({}, e.defaultAdapter, n)) || this;
          return o.shakeAnimationEndHandler_ = function () {
            return o.handleShakeAnimationEnd_();
          }, o;
        }

        return r.b(e, t), Object.defineProperty(e, "cssClasses", {
          get: function get() {
            return i;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "defaultAdapter", {
          get: function get() {
            return {
              addClass: function addClass() {},
              removeClass: function removeClass() {},
              getWidth: function getWidth() {
                return 0;
              },
              registerInteractionHandler: function registerInteractionHandler() {},
              deregisterInteractionHandler: function deregisterInteractionHandler() {}
            };
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.init = function () {
          this.adapter_.registerInteractionHandler("animationend", this.shakeAnimationEndHandler_);
        }, e.prototype.destroy = function () {
          this.adapter_.deregisterInteractionHandler("animationend", this.shakeAnimationEndHandler_);
        }, e.prototype.getWidth = function () {
          return this.adapter_.getWidth();
        }, e.prototype.shake = function (t) {
          var n = e.cssClasses.LABEL_SHAKE;
          t ? this.adapter_.addClass(n) : this.adapter_.removeClass(n);
        }, e.prototype.float = function (t) {
          var n = e.cssClasses,
              r = n.LABEL_FLOAT_ABOVE,
              o = n.LABEL_SHAKE;
          t ? this.adapter_.addClass(r) : (this.adapter_.removeClass(r), this.adapter_.removeClass(o));
        }, e.prototype.handleShakeAnimationEnd_ = function () {
          var t = e.cssClasses.LABEL_SHAKE;
          this.adapter_.removeClass(t);
        }, e;
      }(o.a);

      e.default = a;
    },
    168: function _(t, e, n) {
      "use strict";

      n.r(e);
      var r = n(22),
          o = n(29),
          i = {
        NOTCH_ELEMENT_SELECTOR: ".mdc-notched-outline__notch"
      },
          a = {
        NOTCH_ELEMENT_PADDING: 8
      },
          s = {
        NO_LABEL: "mdc-notched-outline--no-label",
        OUTLINE_NOTCHED: "mdc-notched-outline--notched",
        OUTLINE_UPGRADED: "mdc-notched-outline--upgraded"
      };
      n.d(e, "MDCNotchedOutlineFoundation", function () {
        return c;
      });
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */

      var c = function (t) {
        function e(n) {
          return t.call(this, r.a({}, e.defaultAdapter, n)) || this;
        }

        return r.b(e, t), Object.defineProperty(e, "strings", {
          get: function get() {
            return i;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "cssClasses", {
          get: function get() {
            return s;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "numbers", {
          get: function get() {
            return a;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "defaultAdapter", {
          get: function get() {
            return {
              addClass: function addClass() {},
              removeClass: function removeClass() {},
              setNotchWidthProperty: function setNotchWidthProperty() {},
              removeNotchWidthProperty: function removeNotchWidthProperty() {}
            };
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.notch = function (t) {
          var n = e.cssClasses.OUTLINE_NOTCHED;
          t > 0 && (t += a.NOTCH_ELEMENT_PADDING), this.adapter_.setNotchWidthProperty(t), this.adapter_.addClass(n);
        }, e.prototype.closeNotch = function () {
          var t = e.cssClasses.OUTLINE_NOTCHED;
          this.adapter_.removeClass(t), this.adapter_.removeNotchWidthProperty();
        }, e;
      }(o.a);

      e.default = c;
    },
    22: function _(t, e, n) {
      "use strict";

      n.d(e, "b", function () {
        return o;
      }), n.d(e, "a", function () {
        return _i;
      });
      "function" == typeof Symbol && Symbol.iterator;
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */

      var _r2 = function r(t, e) {
        return (_r2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(t, e);
      };

      function o(t, e) {
        function n() {
          this.constructor = t;
        }

        _r2(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
      }

      var _i = function i() {
        return (_i = Object.assign || function (t) {
          for (var e, n = 1, r = arguments.length; n < r; n++) {
            for (var o in e = arguments[n]) {
              Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            }
          }

          return t;
        }).apply(this, arguments);
      };
    },
    29: function _(t, e, n) {
      "use strict";

      n.d(e, "a", function () {
        return r;
      });
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */

      var r = function () {
        function t(t) {
          void 0 === t && (t = {}), this.adapter_ = t;
        }

        return Object.defineProperty(t, "cssClasses", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t, "strings", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t, "numbers", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t, "defaultAdapter", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.init = function () {}, t.prototype.destroy = function () {}, t;
      }();
    }
  });
});